import React, { useEffect, useState } from "react";
import { BookOpen } from "lucide-react";
import BookCard from "../common/BookCard";
import BundleOffer from "../common/BundleOffer";
import { fetchBooks } from "../../lib/api";

export default function PortalBooks() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBooks().then(setBooks).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-5" data-testid="portal-books">
      <div>
        <h1 className="font-serif text-2xl font-bold text-navy flex items-center gap-2">
          <BookOpen className="h-6 w-6 text-gold-dark" /> Books & Digital Downloads
        </h1>
        <p className="text-gray-500 text-sm mt-0.5">
          Books by Phil Dickens — buy once, download instantly as PDF.
        </p>
      </div>
      {loading ? (
        <p className="text-gray-400 text-sm py-10 text-center">Loading books…</p>
      ) : (
        <>
          <BundleOffer />
          <div className="grid md:grid-cols-2 gap-6">
            {books.map((b) => (
              <BookCard key={b.id} book={b} />
            ))}
            {books.length === 0 && (
              <p className="md:col-span-2 text-gray-400 text-sm py-10 text-center">No books available yet.</p>
            )}
          </div>
        </>
      )}
    </div>
  );
}
